<div class="row-container header-width section" *ngIf="viewModel.apiResult().meta as meta">
  <button class="relative" appFocusRemove (click)="openGallery()">
    <app-image-loading
      [clickable]="true"
      [targetWidth]="500"
      [targetHeight]="500"
      [priority]="true"
      [src]="(viewModel.hoverProductImg() || viewModel.currProductImg())"
      [alt]="meta.name"/>
    <app-image-loading class="view-button"
                       src="assets/icon_product_search.svg" alt="看大圖" i18n-alt
                       [clickable]="true"
                       [targetWidth]="20"
                       [targetHeight]="20"/>
  </button>
  <div class="product-info">
    <div class="title full-width center-container space-between">
      {{meta.name}}（{{viewModel.currColor()?.color?.name ?? ''}}{{
        viewModel.currSize()?.size?.name ? '－' + viewModel.currSize()?.size?.name : ''
      }}）
    </div>
    @if (viewModel.detectService.isPreviewWebsite()) {
      <br/>
      <div class="title">
        <span>商品編號：</span>
        @if (viewModel.apiResult().meta && viewModel.currColor()?.color && viewModel.currSize()?.size) {
          <span>{{viewModel.apiResult().meta?.productId}}{{viewModel.currColor()?.color?.id}}{{viewModel.currSize()?.size?.id}}0</span>
        }
      </div>
    }
    <div class="price-container border-bottom">
      <div class="tag">NT$</div>
      <div class="price">{{(meta.promotionPrice || meta.originPrice) | price}}</div>
      <div class="origin-price line-through" [class.hidden]="!meta.promotionPrice">
        NT$&nbsp;{{meta.originPrice | price}}
      </div>
      @if (viewModel.apiResult().promotion; as promotion) {
        @if (promotion.id && promotion.name) {
          <a class="promotion" [routerLink]="viewModel.saleEventUrl()">
            {{promotion.name}}
          </a>
        }
      }
      <div class="flex-grow"><!--EMPTY--></div>
      <div class="icon-container row-container">
        <button appFocusRemove (click)="toggleFavorite(viewModel.apiResult().meta?.productId)">
          <app-image-loading alt="收藏" i18n-alt
                             [src]="isFavorite() ? 'assets/icon_product_favorite_full.svg' :'assets/icon_product_favorite.svg'"
                             [clickable]="true"
                             [targetWidth]="24"
                             [targetHeight]="24"/>
        </button>
        <button appFocusRemove (click)="toggleShare()">
          <app-image-loading src="assets/icon_share.svg" alt="分享" i18n-alt
                             [clickable]="true"
                             [targetWidth]="21"
                             [targetHeight]="21"/>
        </button>
      </div>
    </div>
    <div class="border-bottom">
      <div class="grids-color">
        <button class="center-container common-grid-btn" appFocusRemove
                *ngFor="let color of viewModel.apiResult().colors; trackBy: trackByColor"
                [class.selected]="viewModel.currColor()?.id === color.id"
                (click)="viewModel.setColor(color)"
                (mouseenter)="viewModel.onHover(color.id)"
                (mouseleave)="viewModel.onHover('')">
          <app-image-loading
            [clickable]="true"
            [targetWidth]="24"
            [targetHeight]="24"
            [originalQuality]="false"
            [ssrSuffix]="'@2x'"
            [alt]="color.color?.name ?? ''"
            [src]="(color.color?.thumbnail ?? '')"/>
        </button>
      </div>

      <div class="grids-size margin-bottom">
        <ng-container *ngFor="let sizeInfo of viewModel.availableSizes(); trackBy: trackBySize">
          <button class="common-grid-btn size-button text-ellipsis" appFocusRemove
                  *ngIf="sizeInfo.inventory && (sizeInfo.inventory.num > 0 || sizeInfo.inventory.stockRemind)"
                  [class.selected]="viewModel.currSize()?.size?.name === sizeInfo.size.name"
                  [class.size-disable]="!sizeInfo.inventory.num"
                  (click)="viewModel.setSize(sizeInfo)">
            {{sizeInfo.size.name}}{{sizeInfo.size.suffix ? '(' + sizeInfo.size.suffix + ')' : ''}}
          </button>
        </ng-container>
      </div>
    </div>
    <div class="info-container row-container space-between border-bottom">
      <button appFocusRemove class="center-container hover-underline"
              (click)="openProductInfo(infoType.PRODUCT_DETAIL)">
        <app-image-loading src="assets/ic_description.svg" alt="產品說明" i18n-alt
                           [clickable]="true"
                           [targetWidth]="22"
                           [targetHeight]="22"/>
        <span class="padding-left" i18n>產品說明</span>
      </button>

      <button appFocusRemove class="center-container hover-underline"
              (click)="openProductInfo(infoType.SIZE_TABLE)">
        <app-image-loading src="assets/icon_product_size.svg" alt="商品尺寸表" i18n-alt
                           [clickable]="true"
                           [targetWidth]="22"
                           [targetHeight]="22"/>
        <span class="padding-left" i18n>商品尺寸表</span>
      </button>

      <button appFocusRemove class="center-container hover-underline"
              (click)="openProductInfo(infoType.RATING)">
        <app-image-loading src="assets/icon_product_comment.svg" alt="評價" i18n-alt
                           [clickable]="true"
                           [targetWidth]="22"
                           [targetHeight]="22"/>
        <span class="padding-left" i18n>評價 ({{viewModel.apiResult().ratingCount}})</span>
      </button>
    </div>
    <div class="row-container buy-margin">
      <app-stepper [current]="viewModel.count()"
                   [disabled]="viewModel.outOfStock()"
                   [max]="viewModel.currSize()?.inventory?.num ?? 0"
                   [remindExceededMax]="true"
                   [stepperWidth]="140"
                   [btnSize]="35"
                   (count)="viewModel.setCount($event)"/>
      @if (viewModel.outOfStock()) {
        <button appFocusRemove class="buy-btn remind-btn"
                (click)="viewModel.addToCart(toast)">
          <span i18n>
            <app-image-loading class="notify-icon" src="assets/icon_mail.svg" alt="通知" i18n-alt
                               [clickable]="true"
                               [targetWidth]="24"
                               [targetHeight]="24"/>
            貨到通知我
          </span>
        </button>
      } @else {
        <button appFocusRemove class="buy-btn common-button"
                (click)="viewModel.addToCart(toast)">
          <span i18n>加入購物車</span>
        </button>
      }
    </div>
    <!-- 免運活動、海外運送提醒 -->
    @if (viewModel.apiResult().shippingFee?.promotionTitle; as feePromotion) {
      <div class="fee-promotion">{{feePromotion}}</div>
    }
    @if (viewModel.apiResult().shippingFee?.deliveryTitle; as deliveryTitle) {
      <div class="fee-promotion">{{deliveryTitle}}</div>
    }
    @if (showDetailLink) {
      <button class="check-detail full-width" appFocusRemove (click)="openProduct()">
        <span i18n>查看商品詳情</span>
        <app-image-loading class="padding-left" alt="查看商品詳情" i18n-alt
                           src="assets/icon_arrow_right_brown.svg"
                           [clickable]="true"
                           [targetWidth]="9"
                           [targetHeight]="16"/>
      </button>
    }
  </div>
</div>
